"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var UsersSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M4,14 C3.44771525,14 3,13.5522847 3,13 L3,12 C3,9.8948158 4.30102603,8.09350251 6.14289226,7.35624595 C5.44680015,6.80685854 5,5.95560715 5,5 C5,3.34314575 6.34314575,2 8,2 C8.92684367,2 9.75551918,2.42030786 10.3058217,3.08071874 C10.5286313,3.02793551 10.7610533,3 11,3 C12.6568542,3 14,4.34314575 14,6 C14,6.95560715 13.5531998,7.80685854 12.8571077,8.35624595 C14.698974,9.09350251 16,10.8948158 16,13 L16,14 C16,14.5522847 15.5522847,15 15,15 L7,15 C6.44771525,15 6,14.5522847 6,14 L4,14 Z M8,3 C6.8954305,3 6,3.8954305 6,5 C6,5.74028236 6.40219863,6.38662619 7,6.73243561 L7,8.12601749 C5.27477279,8.57006028 4,10.1361606 4,12 L4,13 L6,13 C6,10.8948158 7.30102603,9.09350251 9.14289226,8.35624595 C8.44680015,7.80685854 8,6.95560715 8,6 C8,4.96098679 8.5281979,4.04534081 9.3307244,3.50693135 C8.97720039,3.19162438 8.51097833,3 8,3 Z M7,13 L7,14 L15,14 L15,13 C15,11.1361606 13.7252272,9.57006028 12,9.12601749 L12,7.73243561 C12.5978014,7.38662619 13,6.74028236 13,6 C13,4.8954305 12.1045695,4 11,4 C9.8954305,4 9,4.8954305 9,6 C9,6.74028236 9.40219863,7.38662619 10,7.73243561 L10,9.12601749 C8.27477279,9.57006028 7,11.1361606 7,13 Z" })));
};
UsersSmall.displayName = 'UsersSmall';
exports.default = UsersSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=UsersSmall.js.map